const firebaseConfig = {
    apiKey: "AIzaSyDvsXHEt5h4VyfufWIG1u5RcqAccMcVV1k",
    authDomain: "alga-web-messages.firebaseapp.com",
    projectId: "alga-web-messages",
    storageBucket: "alga-web-messages.appspot.com",
    messagingSenderId: "902316780802",
    appId: "1:902316780802:web:f5e590acb6100375ca261b",
    measurementId: "G-9Q1QNZQS31"
};

export default firebaseConfig;